import React from "react";

const GamePrivacyPolicy = () => {
  return (
    <div style={{ maxWidth: "900px", margin: "auto", padding: "40px", whiteSpace: "pre-line", lineHeight: "1.7" }}>

{`
Privacy Policy

Effective date: 2026-03-10
Privacy Policy 

This Privacy Policy applies to the FUNPRO GAMES (SMC-PRIVATE) LIMITED, referred to as the Application, for mobile devices. The Application is provided by FUNPRO GAMES (SMC-PRIVATE) LIMITED, referred to as the Service Provider, as a free service. The Application is provided for use as is.

(1). Information We Collect

A. Information you provide
The Service Provider may collect information you provide when you use the Application, for example:
(1) Email address, if you contact support or submit a request.
(2) Messages and content you send to support.
(3) Any information you choose to share through support forms or email.

B. Information collected automatically
When you download, install, or use the Application, the Application and its SDK partners may automatically collect certain information, for example:
(1) Device information, such as device model, manufacturer, screen size, OS version, language, time zone, and network type.
(2) Identifiers, such as Android Advertising ID, app instance identifiers, and other device level identifiers used for analytics, fraud prevention, and advertising.
(3) Log information, such as IP address, timestamp, app version, and diagnostic logs.
(4) Usage information, such as:
  (A) Screens or pages you view inside the Application.
  (B) The date and time of your activity.
  (C) Session duration and time spent in the Application.
  (D) Events related to gameplay, progress, features used, and interactions.
(5) Performance information, such as crash reports, app responsiveness, and error logs.

C. Location information
The Application does not collect your precise GPS location. The Service Provider and partners may infer approximate location from IP address for analytics, fraud prevention, regional settings, and advertising delivery.

2. How We Use Your Information

The Service Provider uses collected information to:
1) Provide and operate the Application.
2) Improve gameplay, features, stability, and user experience.
3) Monitor performance, detect crashes, and fix bugs.
4) Measure marketing performance and app installs.
5) Show ads and manage monetization, including ad frequency capping, attribution, and fraud prevention.
6) Comply with legal obligations and enforce policies.
7) Communicate with you when you contact support.
8) Send important notices about changes, security, or required service messages.
9) If you have provided your email for updates or support, the Service Provider may also send service related messages. Marketing messages, if any, will follow applicable rules and opt out options where required by law.

3. Advertising, Analytics, and Monetization

The Application may display advertisements and use analytics tools. These services may collect and process identifiers such as Advertising ID, IP address, device information, and app activity data to:
1) Deliver ads, including interest based ads where allowed.
(2) Measure ad performance and app attribution.
(3) Prevent fraud and protect advertising systems.
(4) Limit repeated ads and manage ad frequency.

Personalized advertising controls
You can reduce personalized ads by using Android settings:
(1) Turn off ad personalization in your Google settings, if available in your region.
(2) Reset your Advertising ID from Android settings.
Note that you may still see ads, but they may be less relevant.

4. Third Party Services

The Application uses third-party SDKs and services. These third parties may collect information as described above and process it under their own privacy policies. Some SDKs may not be present in every version, region, or device configuration.
`}
      
<p>
A. Google Play Services<br/>
<a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
Google Play Services Privacy Policy
</a>
</p>

<p>
B. Firebase Analytics, Google Analytics for Firebase<br/>
<a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
Google Privacy Policy
</a>
</p>

<p>
C. Google AdMob Privacy Policy<br/>
<a href="https://support.google.com/admob/answer/6128543" target="_blank" rel="noopener noreferrer">
Google AdMob Privacy Policy
</a>
</p>

<p>
D. Unity Ads<br/>
<a href="https://unity.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer">
Unity Ads Privacy Policy
</a>
<br/>
<a href="https://unity.com/legal/game-player-and-app-user-privacy-policy" target="_blank" rel="noopener noreferrer">
Unity Game Player and App User Privacy Policy
</a>
</p>

<p>
E. AppLovin<br/>
<a href="https://www.applovin.com/privacy/" target="_blank" rel="noopener noreferrer">
AppLovin Privacy Policy
</a>
</p>

<p>
F. ironSource<br/>
<a href="https://developers.is.com/ironsource-mobile/air/ironsource-mobile-privacy-policy/" target="_blank" rel="noopener noreferrer">
ironSource Privacy Policy
</a>
</p>

<p>
G. Meta Audience Network, Meta services<br/>
<a href="https://www.facebook.com/privacy/policy/" target="_blank" rel="noopener noreferrer">
Meta Privacy Policy
</a>
</p>

<p>
H. Mintegral<br/>
<a href="https://www.mintegral.com/en/privacy/" target="_blank" rel="noopener noreferrer">
Mintegral Privacy Policy
</a>
</p>

<p>
I. Pangle<br/>
<a href="https://www.pangleglobal.com/privacy" target="_blank" rel="noopener noreferrer">
Pangle Privacy Policy
</a>
</p>

<p>
J. Liftoff Monetize<br/>
<a href="https://liftoff.io/privacy-policy/" target="_blank" rel="noopener noreferrer">
Liftoff Monetize Privacy Policy
</a>
</p>

<p>
K. Game Analytics Privacy Notice<br/>
<a href="https://gameanalytics.com/privacy/" target="_blank" rel="noopener noreferrer">
Game Analytics Privacy Policy
</a>
</p>

<p>
L. Yandex Ads<br/>
<a href="https://yandex.com/legal/confidential/" target="_blank" rel="noopener noreferrer">
Yandex Ads Privacy Policy
</a>
</p>

<p>
M. Solar Engine<br/>
<a href="https://solar-engine.com/privacy-policy/" target="_blank" rel="noopener noreferrer">
Solar Engine Privacy Policy
</a>
</p>

<p>
N. Bid Machine<br/>
<a href="https://www.bidmachine.io/privacy-policy" target="_blank" rel="noopener noreferrer">
Bid Machine Privacy Policy
</a>
</p>

<div style={{whiteSpace:"pre-line"}}>

{`

5. Sharing of Information:

The Service Provider may share information in these cases:

A. With service providers and partners
The Service Provider may share User Provided and Automatically Collected Information with trusted third-party partners who help operate, analyze, advertise, monetize, or improve the Application.

B. For legal and safety reasons
The Service Provider may disclose information if required by law or necessary to protect users or investigate fraud.

C. Business transfers
If the Service Provider is involved in a merger or acquisition, your information may be transferred as part of that transaction.

6. Data Retention

The Service Provider retains User Provided data for as long as needed to provide the Application and comply with legal obligations.

If you want the Service Provider to delete User Provided Data that you provided through the Application, contact:
developer@funprogames.com.pk

7. Your Choices

You can control your data in these ways:
1) Uninstall the Application to stop further data collection.
2) Use Android settings to manage Advertising ID.
3) Contact support to request deletion of information.

8. Children’s Privacy

The Application is not intended for children under the age of 13.

9. Security

The Service Provider uses reasonable safeguards to protect information.

10. International Processing

Your information may be processed in countries other than your own.

11. Artificial Intelligence

The Application does not provide in-app AI features that process personal data.

12. Changes to This Privacy Policy

This Privacy Policy may be updated from time to time.

Effective date: 2026-02-23

13. Your Consent

By using the Application, you consent to the collection and use of your information as described in this Privacy Policy.

14. Contact Us

FUNPRO GAMES (SMC-PRIVATE) LIMITED
Email: developer@funprogames.com.pk
`}
</div>

    </div>
  );
};

export default GamePrivacyPolicy;